export default __webpack_public_path__ + "static/media/UP.ea19c94e.svg";